import { T } from "./exports";
import { Field, SH, Toggle } from "./UIHelper";
import { DEFAULT_KIOSK_SETTINGS } from "../Widgets/KioskIdle";

const box = { background: T.bgCard, border: `1px solid ${T.border}`, borderRadius: 4, padding: 7, marginBottom: 6 };
const hint = { fontSize: 8, color: T.textMute, lineHeight: 1.5, marginTop: 2 };

export function KioskSettingsPanel({ settings, onChange, screens }) {
  const s = { ...DEFAULT_KIOSK_SETTINGS, ...(settings || {}) };
  const u = (k, v) => onChange({ ...s, [k]: v });
  const homeValid = screens.some(sc => sc.id === s.homeScreenId);
  const minutes = Math.round((Number(s.idleTimeoutSec) || 0) / 6) / 10;

  return <div style={{ padding: "0 8px 8px", overflowY: "auto", flex: 1 }}>
    <SH ch="Home Screen" color={T.green} />
    <div style={box}>
      <Field label="Home screen" value={homeValid ? s.homeScreenId : ""} onChange={v => u("homeScreenId", v)}
        opts={[{ value: "", label: `First screen (${screens[0]?.name || "—"})` }, ...screens.map(sc => ({ value: sc.id, label: sc.name }))]} />
      <div style={hint}>The kiosk starts here, and returns here after inactivity. Going to the home screen also clears search text and selections.</div>
    </div>

    <SH ch="Inactivity" color={T.green} />
    <div style={box}>
      <Toggle label="Return home when inactive" value={s.idleEnabled !== false} onChange={v => u("idleEnabled", v)} />
      {s.idleEnabled !== false && <>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 3 }}>
          <Field label="Inactive after (min)" type="number" step={0.5} value={minutes} onChange={v => u("idleTimeoutSec", Math.max(5, Math.round(Number(v) * 60)))} />
          <Field label="= seconds" type="number" value={s.idleTimeoutSec} onChange={v => u("idleTimeoutSec", Math.max(5, Number(v) || 5))} />
        </div>
        <Toggle label="Ask before going home" value={s.idlePromptEnabled !== false} onChange={v => u("idlePromptEnabled", v)} />
        {s.idlePromptEnabled !== false && <Field label="Popup countdown (sec)" type="number" value={s.idlePromptSec} onChange={v => u("idlePromptSec", Math.max(1, Number(v) || 1))} />}
        <div style={hint}>
          {s.idlePromptEnabled !== false
            ? `After ${minutes} min with no touch, a popup asks to continue or go home. If nobody answers within ${s.idlePromptSec}s the kiosk goes to the home screen. On the home screen itself it resets quietly.`
            : `After ${minutes} min with no touch the kiosk goes straight to the home screen.`}
        </div>
      </>}
    </div>

    {s.idleEnabled !== false && s.idlePromptEnabled !== false && <>
      <SH ch="Popup Text" color={T.green} />
      <div style={box}>
        <Field label="Title" value={s.idleTitle} onChange={v => u("idleTitle", v)} />
        <Field label="Message" rows={4} value={s.idleMessage} onChange={v => u("idleMessage", v)} />
        <div style={{ ...hint, marginBottom: 5 }}>Use <span style={{ color: T.blueLt, fontFamily: "monospace" }}>{"{minutes}"}</span> for the inactivity time.</div>
        <Field label="Continue button" value={s.idleContinueLabel} onChange={v => u("idleContinueLabel", v)} />
        <Field label="Home button" value={s.idleHomeLabel} onChange={v => u("idleHomeLabel", v)} />
        <Field label="Accent colour" type="color" value={s.idleAccentColor} onChange={v => u("idleAccentColor", v)} />
      </div>
    </>}
  </div>;
}
